export type TOutreachType =
  | 'call'
  | 'text'
  | 'canvass'
  | 'ivr'
  | 'text-survey'
  | 'tag'
  | 'notes'
  | 'survey'
  | 'mail'
  | 'relational';

export const OutreachTypeValues: TOutreachType[] = [
  'canvass',
  'call',
  'text',
  'text-survey',
  'ivr',
  'survey',
  'tag',
  'notes',
  'survey',
  'mail',
  'relational',
];

export const formatOutreachType = (type: TOutreachType) => {
  switch (type) {
    case 'call':
      return 'Calls';
    case 'text':
      return 'Texts';
    case 'canvass':
      return 'Doors';
    case 'ivr':
      return 'IVR';
    case 'text-survey':
      return 'Text Surveys';
    case 'tag':
      return 'Tags';
    case 'notes':
      return 'Notes';
    case 'survey':
      return 'Surveys';
    case 'mail':
      return 'Mail';
    case 'relational':
      return 'Relational';
    default:
      return '';
  }
};
